"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowALeftIcon64Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowALeftIcon64Regular = forwardRef_1.forwardRef('ArrowALeftIcon64Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 64 }, props),
        react_1.default.createElement("path", { d: "M27.56 51.94a1.5 1.5 0 1 1-2.12 2.12L8.681 37.304a7.5 7.5 0 0 1 0-10.606L25.44 9.939a1.5 1.5 0 1 1 2.122 2.122L10.803 28.818A4.481 4.481 0 0 0 9.742 30.5H56a1.5 1.5 0 1 1 0 3H9.742c.216.614.57 1.19 1.061 1.682l16.758 16.757Z" })));
});
